import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { PasswordResetRequestComponent } from './password/password-reset-request/password-reset-request.component';
import { PasswordResetConfirmComponent } from './password/password-reset-confirm/password-reset-confirm.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ShipListComponent } from './ships/ship-list/ship-list.component';
import { ShipFormComponent } from './ships/ship-form/ship-form.component';
import { TideListComponent } from './tides/tide-list/tide-list.component';
import { TideDetailComponent } from './tides/tide-detail/tide-detail.component';
import { IncidenceListComponent } from './incidences/incidence-list/incidence-list.component';
import { CapturesListComponent } from './captures/captures-list/captures-list.component';
import { DiscardsListComponent } from './discards/discards-list/discards-list.component';
import { QuotaListComponent } from './quotas/quota-list/quota-list.component';
import { QuotaListAggregateComponent } from './quotas/quota-list-aggregate/quota-list-aggregate.component';
import { QuotaNewFormComponent } from './quotas/quota-new-form/quota-new-form.component';
import { QuotaDetailComponent } from './quotas/quota-detail/quota-detail.component';
import { PortListComponent } from './ports/port-list/port-list.component';
import { ProfileDetailComponent } from './profile/profile-detail/profile-detail.component';
import { ProfileActivateComponent } from './profile/profile-activate/profile-activate.component';
import { ExportPageComponent } from './export/export-page/export-page.component';
import { ImportPageComponent } from './import/import-page/import-page.component';
import { ErrorPageComponent } from './common/error-page/error-page.component';

import { AuthGuard } from './_guards/auth.guard';
import { QuotaMovementsBatchListComponent } from './quotas/quota-batchs/quota-movements-batch-list/quota-movements-batch-list.component';
import { QuotaMovementsBatchComponent } from './quotas/quota-batchs/quota-movements-batch/quota-movements-batch.component';

import { MapsDashboardComponent } from './maps/maps_dashboard/maps_dashboard.component';
import { MapQuotaComponent } from './maps/maps_quotas/maps_quotas.component';
import { HeatmapCapturesComponent } from './maps/heatmaps_captures/heatmap_captures.component';
import { HeatmapDiscardsComponent } from './maps/heatmaps_discards/heatmap_discards.component';

import { EffortListComponent } from './efforts/effort-list/effort-list.component';
import { EffortFormComponent } from './efforts/effort-form/effort-form.component';
import { NotificationListComponent } from './notifications/notification-list/notification-list.component';
import { NotificationFormComponent } from './notifications/notification-form/notification-form.component';
import { ExpirationListComponent } from './expirations/expiration-list/expiration-list.component';
import { SalesListComponent } from './sales/sales-list/sales-list.component';
import { SaleOffersListComponent } from './sale-offers/sale-offers-list/sale-offers-list.component';
import { SaleOfferFormComponent } from './sale-offers/sale-offer-form/sale-offer-form.component';
import { InfoCommercializationAssociationFormComponent } from './sale-offers/info-commercialization-association-form/info-commercialization-association-form.component';

import { DocumentListComponent } from './documents/document-list/document-list.component';
import { DocumentFormComponent } from './documents/document-form/document-form.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'password-reset-request', component: PasswordResetRequestComponent },
  { path: 'password-reset-confirm/:uid/:token', component: PasswordResetConfirmComponent },
  { path: 'error/:code', component: ErrorPageComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'ships', component: ShipListComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'ships/add', component: ShipFormComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'ships/:id', component: ShipFormComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'tides', component: TideListComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'tides/:id', component: TideDetailComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'incidences', component: IncidenceListComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'notifications', component: NotificationListComponent, canActivate: [AuthGuard], data: { modules: ['avisos'] } },
  { path: 'notifications/:id', component: NotificationFormComponent, canActivate: [AuthGuard], data: { modules: ['avisos'] } },
  { path: 'expirations', component: ExpirationListComponent, canActivate: [AuthGuard], data: { modules: ['caducidades'] } },
  { path: 'captures', component: CapturesListComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'discards', component: DiscardsListComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'quotas', component: QuotaListComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'quotas-aggregated', component: QuotaListAggregateComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'quotas/add', component: QuotaNewFormComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'quotas-batchs', component: QuotaMovementsBatchListComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'quotas-batchs/:id', component: QuotaMovementsBatchComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'quotas/:id', component: QuotaDetailComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'ports', component: PortListComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'profile', component: ProfileDetailComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'profile-activate/:uid/:token', component: ProfileActivateComponent },
  { path: 'export', component: ExportPageComponent, canActivate: [AuthGuard], data: { modules: ['base', 'export'] } },
  { path: 'import', component: ImportPageComponent, canActivate: [AuthGuard], data: { modules: ['base', 'import'] } },
  { path: 'maps-dashboard', component: MapsDashboardComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'maps-quotas', component: MapQuotaComponent, canActivate: [AuthGuard], data: { modules: ['base', 'cuotas'] } },
  { path: 'heatmap-captures', component: HeatmapCapturesComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'heatmap-discards', component: HeatmapDiscardsComponent, canActivate: [AuthGuard], data: { modules: ['base'] } },
  { path: 'efforts', component: EffortListComponent, canActivate: [AuthGuard], data: { modules: ['base', 'esfuerzo'] } },
  { path: 'efforts/add', component: EffortFormComponent, canActivate: [AuthGuard], data: { modules: ['base', 'esfuerzo'] } },
  { path: 'sales', component: SalesListComponent, canActivate: [AuthGuard], data: { modules: ['base', 'ventas'] } },
  { path: 'sale-offers', component: SaleOffersListComponent, canActivate: [AuthGuard], data: { modules: ['base', 'front-comercializacion'] } },
  {
    path: 'sale-offers/config',
    component: InfoCommercializationAssociationFormComponent,
    canActivate: [AuthGuard],
    data: { modules: ['base', 'front-comercializacion'] },
  },
  { path: 'sale-offers/add', component: SaleOfferFormComponent, canActivate: [AuthGuard], data: { modules: ['base', 'front-comercializacion'] } },
  { path: 'sale-offers/:id', component: SaleOfferFormComponent, canActivate: [AuthGuard], data: { modules: ['base', 'front-comercializacion'] } },
  { path: 'documents', component: DocumentListComponent },
  { path: 'documents/add', component: DocumentFormComponent },
  { path: 'documents/:id', component: DocumentFormComponent },
  // otherwise redirect to dashboard
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts